var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntegrationsNudge = function SvgIntegrationsNudge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19568_56553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.52294 4.36525L7.7316 7.46325C8.0936 7.72992 8.0936 8.27059 7.7316 8.53725L3.52294 11.6359C3.08294 11.9599 2.46094 11.6459 2.46094 11.0993V4.90259C2.46094 4.35592 3.08227 4.04125 3.52294 4.36525Z",
    stroke: "#64B1FD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.062 4.36525L13.2707 7.46325C13.6327 7.72992 13.6327 8.27059 13.2707 8.53725L9.062 11.6353C8.622 11.9599 8 11.6453 8 11.0986V4.90259C8 4.35592 8.622 4.04125 9.062 4.36525Z",
    stroke: "#64B1FD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19568_56553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export { SvgIntegrationsNudge as ReactComponent };
export default __webpack_public_path__ + "integrations-nudge.svg";